<template>
  <div>
    <van-nav-bar @click-left="clickBack" title="考勤" left-arrow />
    <van-tabs
      v-model="active"
      swipeable
      sticky
      color="#1989fa"
      line-height="2px"
      line-width="50px"
    >
      <van-tab title="我的考勤">
        <!-- <van-calendar
          :show-title="false"
          :poppable="false"
          :show-confirm="false"
          :style="{ height: '500px' }"
          :formatter="formatter"
          :show-mark="false"
          :min-date="minDate"
          :max-date="maxDate"
        /> -->
        <mySignList />
      </van-tab>
      <van-tab title="班级考勤" name="1">
        <classesAttendance />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import classesAttendance from './classesAttendance1'
import mySignList from './mySignList'
import moment from 'moment'
export default {
  data() {
    return {
      active: '0',
      // calendar: [],
    }
  },
  computed: {
    // minDate() {
    //   return new Date(2020, 0, 1)
    // },
    // maxDate() {
    //   return new Date()
    // },
  },
  components: {
    classesAttendance,
    mySignList,
  },
  mounted() {
    // this.getCalendar()
  },
  methods: {
    clickBack() {
      this.$router.go(-1)
    },
    // formatter(day) {
    //   const date = day.date.getDate()
    //   const d = moment(day.date).format('YYYY-MM-DD')
    //   if (new Date() - new Date(day.date).valueOf() > 0) {
    //     if (this.calendar.length <= 0) {
    //       day.type = 'disabled'
    //       return day
    //     }
    //     for (let i = 0; i < this.calendar.length; i++) {
    //       if (d == this.calendar[i].clockTime) {
    //         day.bottomInfo = this.calendar[i].state
    //         day.className = this.calendar[i].className
    //       } else {
    //         day.type = 'disabled'
    //         return day
    //       }
    //     }
    //     // if (date % 2 == 0) {
    //     //   day.bottomInfo = '未签到'
    //     //   day.bottomInfo = 'nosign'
    //     // } else {
    //     //   day.bottomInfo = '已签到'
    //     //   day.className = 'sign'
    //     // }
    //     day.type = 'middle'
    //     return day
    //   }
    //   day.type = 'disabled'
    //   return day
    // },
    // async getCalendar() {
    //   const { data, code } = await this.$https.getCalendar({
    //     userId: this.$store.state.userId,
    //   })
    //   if (code !== 200) {
    //     return false
    //   }
    //   const map = {
    //     '-1': ['迟到', ''],
    //     '0': ['未签到', 'nosign'],
    //     '1': ['已签到', 'sign'],
    //   }
    //   this.calendar = data.map((item) => {
    //     if (!item.amFirstClockState) {
    //       return item
    //     }
    //     item.clockTime = moment(item.clockTime).format('YYYY-MM-DD')
    //     item.state = map[item.amFirstClockState + ''][0]
    //     item.className = map[item.amFirstClockState][1]
    //     return item
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
::deep .van-calendar__day {
  /* background: #ee0a24;
  opacity: 0.1;
  color: #ee0a24; */
  &.sign {
    color: #1bcebc;
  }
  &.nosign {
    color: #ee0a24;
  }
}
</style>
